import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { formatCounterAmount } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'

interface IncidenceProps {
  allowanceIncidence: number
  isHourlyFixedBalance: boolean
}

const Incidence = ({ allowanceIncidence, isHourlyFixedBalance }: IncidenceProps) => {
  return (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Text.Normal>{i18n.t('time_off.allowance_tooltip.holiday')}</Text.Normal>
      <Text.Normal>{formatCounterAmount(allowanceIncidence, isHourlyFixedBalance)}</Text.Normal>
    </Box>
  )
}

export default observer(Incidence)
